// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__3iyqc","productName":"Table_productName__39Sac"};